import React from 'react';
type CTAButtonProps = {
  text: string;
};
export function CTAButton({
  text
}: CTAButtonProps) {
  return <a href="https://getbioform.com/pages/muscledefense" className="block w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg text-center transition-colors duration-200" data-id="element-247">
      {text}
    </a>;
}